<template>
    <div class="content-accountcode container">
        <HeaderIntern/>
        <div class="d-none d-lg-block content-table">
            <div class="overflow-auto content-table-int">
                <b-table
                    id="my-codes"
                    :fields="fields"
                    :items="items"
                    :per-page="perPage"
                    :current-page="currentPage"
                    small
                    @row-clicked="openCodeDetailModal"
                    >
                    <template v-slot:cell(status)="data">
                        <span :class="data.item.className">{{ data.item.status }}</span>
                    </template>
                </b-table>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-codes"
                    align="right"
                    first-number
                    last-number
                ></b-pagination>
            </div>
        </div>
        <div class="d-lg-none">
            <div class="table-mobile" v-for="code,i in items" :key="i">
                <ul @click="openDetailModal(code)">
                    <li>{{ code.date }}</li>
                    <li>{{ code.store}}</li>
                    <li style="font-size: 18px; font-family: 'Font Bold'; text-transform: uppercase;">{{ code.name }}</li>
                    <li><p :class="code.className" style="max-width: 150px; text-align: center;">{{ code.status }}</p></li>
                </ul>
            </div>
        </div>
        <CodeDetail :code="codeDetail"/>
    </div>  
  </template>
  
<script>
import HeaderIntern from '../../components/headers/HeaderIntern.vue';
import CodeDetail from '../../components/modals/CodeDetail.vue';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
    name: 'AccountCode',
    components: {
        HeaderIntern,
        CodeDetail,
    },
    data() {
    return {
        codeDetail: {},
        perPage: 10,
        currentPage: 1,
        fields: [
        {
            key: 'date',
            label: 'Data',
        },
        {
            key: 'store',
            label: 'Estabelecimento',
        },
        {
            key: 'name',
            label: 'Oferta',
        },
        {
            key: 'status',
            label: '',
        },
    ],
        items: [],
    }
    },
    computed: {
        ...mapGetters(["user"]),
        rows() {
            return this.items.length
        },
    },

    methods: {
        openCodeDetailModal(item, index) {
            const realIndex = (this.currentPage - 1) * this.perPage + index;
            const clickedItem = this.items[realIndex];
            this.codeDetail = clickedItem;
            this.$bvModal.show('modal-codedetail');
        },
        openDetailModal(code) {
            this.codeDetail = code;
            this.$bvModal.show('modal-codedetail');
        },
        getPrizes(){
            axios.post('/api/v1/user/prizes', {
                user_id: this.user.id,
            }).then((response) => {
                if (response.data.success === true) {
                    this.items = response.data.data;
                    this.checkStatus();
                } else {
                    this.$swal.fire({
                        type: 'error',
                        title: 'Erro',
                        text: response.data.message,
                        timer: 3000,
                    });
                }
            }).catch((error) => {
                this.$swal.fire({
                    type: 'error',
                    title: 'Erro',
                    text: error,
                    timer: 3000,
                });
            });
        },
        checkStatus() {
        this.items.forEach((item) => {
            let className = "";
            if (item.status === "validado") {
            className = "validado";
            } else if (item.status === "anulado") {
            className = "rejeitado";
            } else {
            className = "em-validacao";
            }
            item.className = className;
        });
        },
    },
    mounted() {
        this.getPrizes();
    }
}
</script>
<style lang="scss">
.content-accountcode{
    margin: 220px auto 100px auto;
    width: 100%;
}
.content-table{
    height: 510px;
    max-height: 510px;
    &-int{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 510px;
    }
}
.table {
    margin: 50px auto;
    width: 100%;
}
.table thead tr th{
    border: none !important;
    &:first-child{
        padding-left: 15px;
    }
    &:last-child{
        padding-right: 15px;
    }
}
    
.table td, .table th{
    border: none !important;
    font-family: 'Font Regular';
    font-size: 14px;
    line-height: 23px;
    color: black;
    text-transform: capitalize;
    text-align: left;
    td:first-child {
       padding-left: 15px;
    }
    &:last-child{
        text-align: right;
        padding-right: 15px;
    }
}
.table, tbody tr{
    border-radius: 20px!important;
    td:first-child {
       padding-left: 15px;
    }
    td:last-child {
       padding-right: 15px;
    }
}
tbody tr:hover{
    background-color: var(--main-color);
    border-radius: 20px!important;
    td{
        color: var(--white)!important;
    }
    td:first-child {
       border-bottom-left-radius: 20px;
       border-top-left-radius: 20px;
    }
    td:last-child {
       border-bottom-right-radius: 20px;
       border-top-right-radius: 20px;
    }
}
.table-mobile{
    ul{
        border-bottom: 1px solid black;
        margin: 20px 0;
        padding: 20px 15px;
        position: relative;
        li{
            list-style: none;
            font-family: 'Font Regular';
            font-size: 16px;
            line-height: 22px;
            color: black;
            text-transform: capitalize;
            text-align: left;
            padding: 5px 0;
            &:last-child{
                font-family: 'Font Bold';
                font-size: 18px;
                text-transform: uppercase;
                position: absolute;
                right: 0;
                top: 20px;
            }
        }
    }
}
.pagination{
    border-radius: 0;
    font-family: 'Font Regular';
    font-size: 20px;
    gap: 10px;
}
.page-item{
    padding: 0;
    width: 33px;
    height: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.page-link{
    background-color: #f9f9f9;
    border: none;
    padding: 0;
    color: var(--main-color);
    width: 100%;
    height: 100%;
    line-height: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.page-item.active .page-link{
    background-color: transparent;
    border: none;
    border-radius: 15px;
    text-decoration: underline;
    font-family: 'Font Bold';
    color: black;
}
.page-link:hover, .page-link:focus{
    background-color: transparent;
    border: none;
    border-radius:50%;
    box-shadow: none;
}

.page-item:first-child .page-link{
    border-radius: 50%;
    background-color: var(--white);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.16);
    content: url('../../assets/icons/arrow-left.svg');
    padding: 5px 5px 5px 10px;
}
.page-item:last-child .page-link{
    border-radius: 50%;
    background-color: var(--white);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.16);
    content: url('../../assets/icons/arrow-right.svg');
    padding: 5px 10px 5px 5px;
}
.em-validacao{
    padding: 2px 5px;
    background-color: #FFCF00;
    border-radius: 7px;
}
.rejeitado{
    padding: 2px 10px;
    background-color: #F5891F;
    border-radius: 7px;
}
.validado{
    padding: 2px 5px;
    background-color: #A5E971;
    border-radius: 7px;
}
</style>